<div class="flex-row gap-16">
  <vl-chips
    [matMenuTriggerFor]="familleMenu"
    iconRight="expand_more"
    [state]="buttonState()"
    (action)="menuTrigger.openMenu()"
    #menuTrigger="matMenuTrigger">
    {{ text() }}
  </vl-chips>
  <mat-menu #familleMenu="matMenu" (click)="$event.stopPropagation()">
    <div class="flex-col dates-container">
      <mat-form-field (click)="$event.stopPropagation()" class="w100">
        <mat-label>{{ 'multi_date.date_interval' | trans }}</mat-label>
        <div class="flex-row">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="startDate" [placeholder]="startLabel()"
                   (keydown.tab)="$event.stopPropagation()">
            <input matEndDate [(ngModel)]="endDate" [placeholder]="endLabel()" (keydown.tab)="$event.stopPropagation()">
          </mat-date-range-input>
          <div class="flex-row gap-8">
            @if (startDate() && endDate()) {
              <mat-icon class="cursor-pointer" (click)="onClear()">close</mat-icon>
            }
            <mat-icon class="cursor-pointer" (click)="picker.open()">calendar_month</mat-icon>
          </div>
        </div>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <div class="w100 flex-row gap-4 justify-around">
        <vl-big-button color="basic" [text]="'button.cancel' | trans" (action)="onCancel(); menuTrigger.closeMenu()"/>
        <vl-big-button color="primary" [text]="'button.valid' | trans" (action)="onValid(); menuTrigger.closeMenu()"/>
      </div>
    </div>
  </mat-menu>
</div>
